import { render, staticRenderFns } from "./btn-readmore.vue?vue&type=template&id=3af82ffc&scoped=true"
import script from "./btn-readmore.vue?vue&type=script&lang=js"
export * from "./btn-readmore.vue?vue&type=script&lang=js"
import style0 from "./btn-readmore.vue?vue&type=style&index=0&id=3af82ffc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3af82ffc",
  null
  
)

export default component.exports